import { render, staticRenderFns } from "./DragAndDropImageInput.vue?vue&type=template&id=28bb3520"
import script from "./DragAndDropImageInput.vue?vue&type=script&lang=js"
export * from "./DragAndDropImageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports